export function getInitials(name: string): string {
  if (!name?.trim()) return '';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 1) return parts[0]!.charAt(0).toUpperCase();
  return `${parts[0]!.charAt(0).toUpperCase()}${parts.at(-1)!.charAt(0).toUpperCase()}`;
}
